module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "audit_edit_pf pl10 mt20"
  }, [(_vm.control.schedule) ? _c('div', {
    staticClass: "mt20 mb20"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('div', {
    staticClass: "grid-content"
  }, [_vm._v("审核进展：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('div', {
    staticClass: "grid-content"
  }, [_c('span', {
    staticClass: "main_word"
  }, [_vm._v(_vm._s(_vm.control.schedule))])])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 22,
      "offset": 2
    }
  }, [(_vm.control.content) ? _c('div', {
    staticClass: "grid-content"
  }, [_vm._v("\n                (" + _vm._s(_vm.control.content) + ")")]) : _vm._e()])], 1)], 1) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "dib"
  }, [_vm._v("基础信息")]), _c('span', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.control.view == 1),
      expression: "control.view == 1"
    }],
    staticClass: "mt20"
  }, [_c('el-form', {
    ref: "basicForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.basicForm,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "供应商编码",
      "prop": "suppliersCode",
      "label-width": "207px"
    }
  }, [_c('el-input', {
    staticClass: "w500",
    attrs: {
      "disabled": true,
      "placeholder": "请输入供应商编码"
    },
    model: {
      value: (_vm.basicForm.suppliersCode),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "suppliersCode", $$v)
      },
      expression: "basicForm.suppliersCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "供应商名称",
      "prop": "suppliersName",
      "label-width": "207px"
    }
  }, [_c('el-input', {
    staticClass: "w500",
    attrs: {
      "placeholder": "请输入供应商名称"
    },
    model: {
      value: (_vm.basicForm.suppliersName),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "suppliersName", $$v)
      },
      expression: "basicForm.suppliersName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "dib",
    attrs: {
      "label": "办公地址",
      "label-width": "207px"
    }
  }, [_c('span', {
    staticClass: "main_word rule_star vtb"
  }, [_vm._v("*")]), _vm._v(" "), _c('el-select', {
    staticClass: "ml_10",
    attrs: {
      "placeholder": "请选择国家"
    },
    on: {
      "change": _vm.getOfficeProvince
    },
    model: {
      value: (_vm.basicForm.officeCountry),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "officeCountry", $$v)
      },
      expression: "basicForm.officeCountry"
    }
  }, _vm._l((_vm.countryList), function(val) {
    return _c('el-option', {
      key: val.id,
      attrs: {
        "label": val.name,
        "value": val.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "sign_address dib ",
    attrs: {
      "label-width": "0px"
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.isForeign,
      "placeholder": "请选择省份"
    },
    on: {
      "change": _vm.getOfficeCity
    },
    model: {
      value: (_vm.basicForm.officeProvince),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "officeProvince", $$v)
      },
      expression: "basicForm.officeProvince"
    }
  }, _vm._l((_vm.provinceList), function(val) {
    return _c('el-option', {
      key: val.id,
      attrs: {
        "label": val.name,
        "value": val.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "dib sign",
    attrs: {
      "label-width": "0px"
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.isForeign,
      "placeholder": "请选择城市"
    },
    on: {
      "change": _vm.getOfficeDistrict
    },
    model: {
      value: (_vm.basicForm.officeCity),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "officeCity", $$v)
      },
      expression: "basicForm.officeCity"
    }
  }, _vm._l((_vm.cityList), function(val) {
    return _c('el-option', {
      key: val.id,
      attrs: {
        "label": val.name,
        "value": val.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "dib sign",
    attrs: {
      "label-width": "0px"
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.isForeign,
      "placeholder": "请选择区县"
    },
    model: {
      value: (_vm.basicForm.officeDistrict),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "officeDistrict", $$v)
      },
      expression: "basicForm.officeDistrict"
    }
  }, _vm._l((_vm.districtList), function(val) {
    return _c('el-option', {
      key: val.id,
      attrs: {
        "label": val.name,
        "value": val.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "officeAddress",
      "label-width": "207px"
    }
  }, [_c('el-input', {
    staticClass: "w500",
    attrs: {
      "autosize": {
        minRows: 4,
        maxRows: 6
      },
      "type": "textarea",
      "placeholder": "请输入您的详细地址"
    },
    model: {
      value: (_vm.basicForm.officeAddress),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "officeAddress", $$v)
      },
      expression: "basicForm.officeAddress"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "mb20"
  }, [_vm._v("供应商资质信息")]), _c('span', {
    staticClass: "second_line"
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "注册登记名称：",
      "prop": "registeredName",
      "label-width": "207px"
    }
  }, [_c('el-input', {
    staticClass: "w500",
    attrs: {
      "placeholder": "请输入注册登记名称"
    },
    model: {
      value: (_vm.basicForm.registeredName),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "registeredName", $$v)
      },
      expression: "basicForm.registeredName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "dib",
    attrs: {
      "label": "注册登记地址：",
      "prop": "registeredCountry",
      "label-width": "207px"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择国家"
    },
    on: {
      "change": _vm.getRegisteredProvince
    },
    model: {
      value: (_vm.basicForm.registeredCountry),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "registeredCountry", $$v)
      },
      expression: "basicForm.registeredCountry"
    }
  }, _vm._l((_vm.countryList), function(val) {
    return _c('el-option', {
      key: val.id,
      attrs: {
        "label": val.name,
        "value": val.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "dib sign",
    attrs: {
      "label-width": "0px"
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.isRegisteredForeign,
      "placeholder": "请选择省份"
    },
    on: {
      "change": _vm.getRegisteredCity
    },
    model: {
      value: (_vm.basicForm.registeredProvince),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "registeredProvince", $$v)
      },
      expression: "basicForm.registeredProvince"
    }
  }, _vm._l((_vm.registeredProvinceList), function(val) {
    return _c('el-option', {
      key: val.id,
      attrs: {
        "label": val.name,
        "value": val.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "dib sign",
    attrs: {
      "label-width": "0px"
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.isRegisteredForeign,
      "placeholder": "请选择城市"
    },
    on: {
      "change": _vm.getRegisteredDistrict
    },
    model: {
      value: (_vm.basicForm.registeredCity),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "registeredCity", $$v)
      },
      expression: "basicForm.registeredCity"
    }
  }, _vm._l((_vm.registeredCityList), function(val) {
    return _c('el-option', {
      key: val.id,
      attrs: {
        "label": val.name,
        "value": val.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "dib sign",
    attrs: {
      "label-width": "0px"
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.isRegisteredForeign,
      "placeholder": "请选择区县"
    },
    model: {
      value: (_vm.basicForm.registeredDistrict),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "registeredDistrict", $$v)
      },
      expression: "basicForm.registeredDistrict"
    }
  }, _vm._l((_vm.registeredDistrictList), function(val) {
    return _c('el-option', {
      key: val.id,
      attrs: {
        "label": val.name,
        "value": val.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "registeredAddress",
      "label-width": "207px"
    }
  }, [_c('el-input', {
    staticClass: "w500",
    attrs: {
      "autosize": {
        minRows: 4,
        maxRows: 6
      },
      "type": "textarea",
      "placeholder": "请输入您的详细地址"
    },
    model: {
      value: (_vm.basicForm.registeredAddress),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "registeredAddress", $$v)
      },
      expression: "basicForm.registeredAddress"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "品类合作类型：",
      "label-width": "207px"
    }
  }, [_c('span', {
    staticClass: "main_word rule_star123 vtb"
  }, [_vm._v("*")]), _vm._v(" "), _c('el-checkbox-group', {
    staticClass: "dib vtb ml_10",
    model: {
      value: (_vm.categoryType),
      callback: function($$v) {
        _vm.categoryType = $$v
      },
      expression: "categoryType"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "1",
      "disabled": _vm.isRegisteredForeign
    }
  }, [_vm._v("图书类")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "2"
    }
  }, [_vm._v("非图书类")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isBook),
      expression: "isBook"
    }],
    staticClass: "dib",
    attrs: {
      "label": "出版社经营许可证电子版：",
      "label-width": "207px"
    }
  }, [_c('span', {
    staticClass: "main_word rule_star3"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', {
    staticClass: "f666 f12"
  }, [_vm._v("复印件需加盖公司红章扫描上传")]), _vm._v(" "), [_c('div', {
    staticClass: "fixeds"
  })], _vm._v(" "), [_c('el-upload', {
    attrs: {
      "action": "/suppliers/uploadImages?biz=0",
      "name": "pic",
      "file-list": _vm.basicForm.publicationBusinessLicenseFile,
      "list-type": "picture-card",
      "on-preview": _vm.handlePictureCardPreview,
      "on-remove": _vm.removePublicationLicense,
      "before-upload": _vm.beforeUpload,
      "on-success": _vm.handlePublicationLicense
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })])], _vm._v(" "), _c('span', {
    staticClass: "f999 f12"
  }, [_vm._v("上传电子版资质仅支持JPG、GIF、PNG等格式的图片，大小不超过1M")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.publicationBusinessLicenseShow),
      expression: "publicationBusinessLicenseShow"
    }],
    staticClass: "pic_tip"
  }, [_vm._v("请上传图片")])], 2), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "注册资金：",
      "prop": "registeredCapital",
      "label-width": "207px"
    }
  }, [_c('el-input', {
    staticClass: "w500",
    attrs: {
      "placeholder": "请输入注册资金",
      "maxlength": 9
    },
    model: {
      value: (_vm.basicForm.registeredCapital),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "registeredCapital", _vm._n($$v))
      },
      expression: "basicForm.registeredCapital"
    }
  }), _vm._v("（单位：万）\n                "), _c('el-radio-group', {
    model: {
      value: (_vm.basicForm.registeredCapitalType),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "registeredCapitalType", $$v)
      },
      expression: "basicForm.registeredCapitalType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_c('span', {
    staticClass: "f14 f666"
  }, [_vm._v("人民币")])]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_c('span', {
    staticClass: "f14 f666"
  }, [_vm._v("美元")])])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.basicForm.licenseType != 3),
      expression: "basicForm.licenseType !=3"
    }],
    attrs: {
      "label": "执照类型：",
      "label-width": "207px"
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.licenseChange
    },
    model: {
      value: (_vm.basicForm.licenseType),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "licenseType", $$v)
      },
      expression: "basicForm.licenseType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_c('span', {
    staticClass: "f14 f666"
  }, [_vm._v("普通营业执照")])]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_c('span', {
    staticClass: "f14 f666"
  }, [_vm._v("三证合一／五证合一")])]), _vm._v(" "), _c('el-radio', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "label": 3
    }
  }, [_c('span', {
    staticClass: "f14 f666"
  }, [_vm._v("国外")])])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "营业执照号：",
      "prop": "businessLicenseCode",
      "label-width": "207px",
      "rules": [{
        required: true,
        message: '营业执照号不能为空',
        trigger: 'blur'
      }]
    }
  }, [_c('el-input', {
    staticClass: "w500",
    attrs: {
      "placeholder": "请输入营业执照号"
    },
    model: {
      value: (_vm.basicForm.businessLicenseCode),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "businessLicenseCode", $$v)
      },
      expression: "basicForm.businessLicenseCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "mt20",
    attrs: {
      "label": "营业执照电子版：",
      "label-width": "207px"
    }
  }, [_c('span', {
    staticClass: "main_word rule_star4"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', {
    staticClass: "f666 f12 ml_10"
  }, [_vm._v("复印件需加盖公司红章扫描上传")]), _vm._v(" "), [_c('div', {
    staticClass: "fixeds"
  })], _vm._v(" "), [_c('el-upload', {
    attrs: {
      "action": "/suppliers/uploadImages?biz=0",
      "name": "pic",
      "file-list": _vm.basicForm.businessLicenseFile,
      "list-type": "picture-card",
      "on-preview": _vm.handlePictureCardPreview,
      "on-remove": _vm.removeBusinessLicense,
      "on-success": _vm.handleBusinessLicense,
      "before-upload": _vm.beforeUpload
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })])], _vm._v(" "), _c('span', {
    staticClass: "f999 f12"
  }, [_vm._v("上传电子版资质仅支持JPG、GIF、PNG等格式的图片，大小不超过1M")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.businessLicenseShow),
      expression: "businessLicenseShow"
    }],
    staticClass: "pic_tip"
  }, [_vm._v("请上传图片")])], 2), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.basicForm.registeredCountry == 1),
      expression: "basicForm.registeredCountry == 1"
    }],
    attrs: {
      "label": "执照有效期：",
      "label-width": "207px"
    }
  }, [_c('span', {
    staticClass: "main_word rule_star105"
  }, [_vm._v("*")]), _vm._v(" "), _c('el-date-picker', {
    staticClass: "ml_10",
    attrs: {
      "type": "daterange",
      "placeholder": "选择执照有效期"
    },
    model: {
      value: (_vm.businessLicenseDate),
      callback: function($$v) {
        _vm.businessLicenseDate = $$v
      },
      expression: "businessLicenseDate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOneCertificate),
      expression: "isOneCertificate"
    }],
    attrs: {
      "label": "组织机构代码：",
      "label-width": "207px"
    }
  }, [_c('span', {
    staticClass: "main_word rule_star2 vtb"
  }, [_vm._v("*")]), _vm._v(" "), _c('el-input', {
    staticClass: "w500 ml_10",
    attrs: {
      "placeholder": "请输入组织机构代码"
    },
    model: {
      value: (_vm.basicForm.orgCode),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "orgCode", $$v)
      },
      expression: "basicForm.orgCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOneCertificate),
      expression: "isOneCertificate"
    }],
    staticClass: "mt20",
    attrs: {
      "label": "组织结构代码电子版：",
      "label-width": "207px"
    }
  }, [_c('span', {
    staticClass: "main_word rule_star5"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', {
    staticClass: "f666 f12 ml_10"
  }, [_vm._v("复印件需加盖公司红章扫描上传")]), _vm._v(" "), [_c('div', {
    staticClass: "fixeds"
  })], _vm._v(" "), [_c('el-upload', {
    attrs: {
      "action": "/suppliers/uploadImages?biz=0",
      "name": "pic",
      "file-list": _vm.basicForm.orgCodeFile,
      "list-type": "picture-card",
      "on-preview": _vm.handlePictureCardPreview,
      "on-remove": _vm.removeOrgCode,
      "on-success": _vm.handleOrgCode,
      "before-upload": _vm.beforeUpload
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })])], _vm._v(" "), _c('span', {
    staticClass: "f999 f12"
  }, [_vm._v("上传电子版资质仅支持JPG、GIF、PNG等格式的图片，大小不超过1M")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.orgCodeShow),
      expression: "orgCodeShow"
    }],
    staticClass: "pic_tip"
  }, [_vm._v("请上传图片")])], 2), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOneCertificate),
      expression: "isOneCertificate"
    }],
    staticClass: "mt20",
    attrs: {
      "label": "税务登记证电子版：",
      "label-width": "207px"
    }
  }, [_c('span', {
    staticClass: "main_word rule_star6"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', {
    staticClass: "f666 f12 ml_10"
  }, [_vm._v("复印件需加盖公司红章扫描上传")]), _vm._v(" "), (!_vm.taxFileShow) ? [_c('div', {
    staticClass: "fixeds"
  })] : _vm._e(), _vm._v(" "), [_c('el-upload', {
    attrs: {
      "action": "/suppliers/uploadImages?biz=0",
      "name": "pic",
      "file-list": _vm.basicForm.taxFile,
      "list-type": "picture-card",
      "on-preview": _vm.handlePictureCardPreview,
      "on-remove": _vm.removeTaxFile,
      "on-success": _vm.handleTaxFile,
      "before-upload": _vm.beforeUpload
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })])], _vm._v(" "), _c('span', {
    staticClass: "f999 f12"
  }, [_vm._v("上传电子版资质仅支持JPG、GIF、PNG等格式的图片，大小不超过1M")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.taxFileShow),
      expression: "taxFileShow"
    }],
    staticClass: "pic_tip"
  }, [_vm._v("请上传图片")])], 2), _vm._v(" "), _c('el-form-item', {
    staticClass: "mt20",
    attrs: {
      "label": "开户许可证电子版：",
      "label-width": "207px"
    }
  }, [_c('span', {
    staticClass: "main_word rule_star6"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', {
    staticClass: "f666 f12 ml_10"
  }, [_vm._v("复印件需加盖公司红章扫描上传")]), _vm._v(" "), [_c('div', {
    staticClass: "fixeds"
  })], _vm._v(" "), [_c('el-upload', {
    attrs: {
      "action": "/suppliers/uploadImages?biz=0",
      "name": "pic",
      "file-list": _vm.basicForm.accountOpeningPermitFile,
      "list-type": "picture-card",
      "on-preview": _vm.handlePictureCardPreview,
      "on-remove": _vm.removeAccountOpeningPermit,
      "on-success": _vm.handleAccountOpeningPermit,
      "before-upload": _vm.beforeUpload
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })])], _vm._v(" "), _c('span', {
    staticClass: "f999 f12"
  }, [_vm._v("上传电子版资质仅支持JPG、GIF、PNG等格式的图片，大小不超过1M")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.accountOpeningPermitShow),
      expression: "accountOpeningPermitShow"
    }],
    staticClass: "pic_tip"
  }, [_vm._v("请上传图片")])], 2), _vm._v(" "), _c('el-form-item', {
    staticClass: "mt20",
    attrs: {
      "label": "法定代表人证件类型：",
      "label-width": "207px"
    }
  }, [_c('span', {
    staticClass: "main_word rule_star5"
  }, [_vm._v("*")]), _vm._v(" "), _c('el-radio-group', {
    staticClass: "ml_10",
    model: {
      value: (_vm.basicForm.personalCardType),
      callback: function($$v) {
        _vm.$set(_vm.basicForm, "personalCardType", $$v)
      },
      expression: "basicForm.personalCardType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_c('span', {
    staticClass: "f14 f666"
  }, [_vm._v("身份证")])]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_c('span', {
    staticClass: "f14 f666"
  }, [_vm._v("护照")])])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "dib mt20",
    attrs: {
      "label": "法定代表人身份证件电子版：",
      "label-width": "207px"
    }
  }, [_c('span', {
    staticClass: "main_word rule_star200"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', {
    staticClass: "f666 f12 ml_10"
  }, [_vm._v("身份证正反两面，同一张A4纸，复印件请加盖公司红章")]), _vm._v(" "), [_c('div', {
    staticClass: "fixeds"
  })], _vm._v(" "), [_c('el-upload', {
    attrs: {
      "action": "/suppliers/uploadImages?biz=0",
      "name": "pic",
      "file-list": _vm.basicForm.personalCardFile,
      "list-type": "picture-card",
      "on-preview": _vm.handlePictureCardPreview,
      "on-remove": _vm.removePersonalCard,
      "on-success": _vm.handlePersonalCard,
      "before-upload": _vm.beforeUpload
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })])], _vm._v(" "), _c('span', {
    staticClass: "f999 f12"
  }, [_vm._v("上传电子版资质仅支持JPG、GIF、PNG等格式的图片，大小不超过1M")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.personalCardShow),
      expression: "personalCardShow"
    }],
    staticClass: "pic_tip"
  }, [_vm._v("请上传图片")])], 2), _vm._v(" "), _c('el-form-item', {
    staticClass: "mt50 mb50",
    staticStyle: {
      "margin-left": "300px"
    }
  }, [_c('el-button', {
    staticClass: "mr10",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.returnPage
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('el-button', {
    staticClass: "mr10",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveForm
    }
  }, [_vm._v("暂存")]), _vm._v(" "), _c('el-button', {
    staticClass: "mr10",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.confirmSubmit('basicForm')
      }
    }
  }, [_vm._v(_vm._s(_vm.control.status == 4 ? '重新提交' : '提交'))])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.control.view == 0),
      expression: "control.view == 0"
    }],
    staticClass: "mt20"
  }, [_c('el-form', {
    staticClass: "demo-ruleForm",
    attrs: {
      "label-width": "207px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "供应商编号："
    }
  }, [_c('div', [_c('span', [_vm._v(_vm._s(_vm.basicForm.suppliersCode))])])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "供应商名称："
    }
  }, [_c('div', [_c('span', [_vm._v(_vm._s(_vm.basicForm.suppliersName))]), _vm._v(" "), (_vm.control.compare == 1 && _vm.oldBasicData.suppliersName) ? _c('span', {
    staticClass: "main_word"
  }, [_vm._v(_vm._s(_vm.oldBasicData.suppliersName))]) : _vm._e()])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "办公地址："
    }
  }, [_c('div', [_c('span', [_vm._v(_vm._s(_vm.basicForm.officeCountryName))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.basicForm.officeProvinceName))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.basicForm.officeCityName))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.basicForm.officeDistrictName))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.basicForm.officeAddress))])]), _vm._v(" "), (_vm.control.compare == 1) ? _c('div', [(_vm.oldBasicData.officeCountryName) ? _c('span', {
    staticClass: "main_word"
  }, [_vm._v(_vm._s(_vm.oldBasicData.officeCountryName))]) : _vm._e(), _vm._v(" "), (_vm.oldBasicData.officeProvinceName) ? _c('span', {
    staticClass: "main_word"
  }, [_vm._v(_vm._s(_vm.oldBasicData.officeProvinceName))]) : _vm._e(), _vm._v(" "), (_vm.oldBasicData.officeCityName) ? _c('span', {
    staticClass: "main_word"
  }, [_vm._v(_vm._s(_vm.oldBasicData.officeCityName))]) : _vm._e(), _vm._v(" "), (_vm.oldBasicData.officeDistrictName) ? _c('span', {
    staticClass: "main_word"
  }, [_vm._v(_vm._s(_vm.oldBasicData.officeDistrictName))]) : _vm._e(), _vm._v(" "), (_vm.oldBasicData.officeAddress) ? _c('span', {
    staticClass: "main_word"
  }, [_vm._v(_vm._s(_vm.oldBasicData.officeAddress))]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "dib"
  }, [_vm._v("供应商资质信息")]), _c('span', {
    staticClass: "second_line"
  }), _vm._v(" "), _c('span', {
    staticClass: "main_word mr4"
  }), _vm._v(" "), (_vm.basicForm.categoryIsBook != 1) ? _c('el-form-item', {
    staticClass: "dib",
    attrs: {
      "label": "公司注册地址："
    }
  }, [_c('div', [_c('span', [_vm._v(_vm._s(_vm.basicForm.registeredCountryName))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.basicForm.registeredProvinceName))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.basicForm.registeredCityName))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.basicForm.registeredDistrictName))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.basicForm.registeredAddress))])]), _vm._v(" "), (_vm.control.compare == 1) ? _c('div', [(_vm.oldBasicData.registeredCountryName) ? _c('span', {
    staticClass: "main_word"
  }, [_vm._v(_vm._s(_vm.oldBasicData.registeredCountryName))]) : _vm._e(), _vm._v(" "), (_vm.oldBasicData.registeredProvinceName) ? _c('span', {
    staticClass: "main_word"
  }, [_vm._v(_vm._s(_vm.oldBasicData.registeredProvinceName))]) : _vm._e(), _vm._v(" "), (_vm.oldBasicData.registeredCityName) ? _c('span', {
    staticClass: "main_word"
  }, [_vm._v(_vm._s(_vm.oldBasicData.registeredCityName))]) : _vm._e(), _vm._v(" "), (_vm.oldBasicData.registeredDistrictName) ? _c('span', {
    staticClass: "main_word"
  }, [_vm._v(_vm._s(_vm.oldBasicData.registeredDistrictName))]) : _vm._e(), _vm._v(" "), (_vm.oldBasicData.registeredAddress) ? _c('span', {
    staticClass: "main_word"
  }, [_vm._v(_vm._s(_vm.oldBasicData.registeredAddress))]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "注册登记名称："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.basicForm.registeredName))]), _vm._v(" "), (_vm.control.compare == 1 && _vm.oldBasicData.registeredName) ? _c('span', {
    staticClass: "main_word"
  }, [_vm._v("   " + _vm._s(_vm.oldBasicData.registeredName))]) : _vm._e()]), _vm._v(" "), (_vm.basicForm.categoryIsBook == 1) ? _c('el-form-item', {
    staticClass: "dib",
    attrs: {
      "label": "公司注册地址："
    }
  }, [_c('div', [_c('span', [_vm._v(_vm._s(_vm.basicForm.registeredCountryName))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.basicForm.registeredProvinceName))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.basicForm.registeredCityName))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.basicForm.registeredDistrictName))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.basicForm.registeredAddress))])]), _vm._v(" "), (_vm.control.compare == 1) ? _c('div', [(_vm.oldBasicData.registeredCountryName) ? _c('span', {
    staticClass: "main_word"
  }, [_vm._v(_vm._s(_vm.oldBasicData.registeredCountryName))]) : _vm._e(), _vm._v(" "), (_vm.oldBasicData.registeredProvinceName) ? _c('span', {
    staticClass: "main_word"
  }, [_vm._v(_vm._s(_vm.oldBasicData.registeredProvinceName))]) : _vm._e(), _vm._v(" "), (_vm.oldBasicData.registeredCityName) ? _c('span', {
    staticClass: "main_word"
  }, [_vm._v(_vm._s(_vm.oldBasicData.registeredCityName))]) : _vm._e(), _vm._v(" "), (_vm.oldBasicData.registeredDistrictName) ? _c('span', {
    staticClass: "main_word"
  }, [_vm._v(_vm._s(_vm.oldBasicData.registeredDistrictName))]) : _vm._e(), _vm._v(" "), (_vm.oldBasicData.registeredAddress) ? _c('span', {
    staticClass: "main_word"
  }, [_vm._v(_vm._s(_vm.oldBasicData.registeredAddress))]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "品类合作类型："
    }
  }, [_c('el-checkbox-group', {
    staticClass: "dib vtb ml_10",
    model: {
      value: (_vm.categoryType),
      callback: function($$v) {
        _vm.categoryType = $$v
      },
      expression: "categoryType"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "1",
      "disabled": ""
    }
  }, [_vm._v("图书类")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "2",
      "disabled": ""
    }
  }, [_vm._v("非图书类")])], 1)], 1), _vm._v(" "), (_vm.basicForm.categoryIsBook == 1) ? _c('el-form-item', {
    staticClass: "dib",
    attrs: {
      "label": "出版社经营许可证电子版："
    }
  }, [_c('div', [_vm._l((_vm.basicForm.publicationBusinessLicenseFile), function(gtFile) {
    return _c('img', {
      staticClass: "pic_skan",
      attrs: {
        "src": gtFile.url
      },
      on: {
        "click": function($event) {
          _vm.previewPic($event)
        }
      }
    })
  }), _vm._v(" "), _vm._l((_vm.oldBasicData.publicationBusinessLicenseFile), function(gtFile) {
    return (_vm.control.compare == 1 && _vm.oldBasicData.publicationBusinessLicenseFile) ? _c('img', {
      staticClass: "pic_skan_red",
      attrs: {
        "src": gtFile.url
      },
      on: {
        "click": function($event) {
          _vm.previewPic($event)
        }
      }
    }) : _vm._e()
  })], 2)]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "注册资金："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.basicForm.registeredCapital) + "（单位：万）")]), _vm._v(" "), (_vm.basicForm.registeredCapitalType == 1) ? _c('span', [_vm._v("人民币")]) : _vm._e(), _vm._v(" "), (_vm.basicForm.registeredCapitalType == 2) ? _c('span', [_vm._v("美元")]) : _vm._e(), _vm._v(" "), (_vm.control.compare == 1 && _vm.oldBasicData.registeredCapital) ? _c('span', {
    staticClass: "main_word"
  }, [_vm._v(_vm._s(_vm.oldBasicData.registeredCapital) + "（单位：万）")]) : _vm._e(), _vm._v(" "), (_vm.control.compare == 1 && _vm.oldBasicData.registeredCapital) ? _c('span', {
    staticClass: "main_word"
  }, [_vm._v("人民币")]) : _vm._e(), _vm._v(" "), (_vm.control.compare == 2 && _vm.oldBasicData.registeredCapital) ? _c('span', {
    staticClass: "main_word"
  }, [_vm._v("美元")]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.basicForm.licenseType != 3),
      expression: "basicForm.licenseType !=3 "
    }],
    attrs: {
      "label": "执照类型："
    }
  }, [(_vm.basicForm.licenseType == 1) ? _c('span', [_vm._v("普通营业执照")]) : _vm._e(), _vm._v(" "), (_vm.basicForm.licenseType == 2) ? _c('span', [_vm._v("三证合一／五证合一")]) : _vm._e(), _vm._v(" "), (_vm.control.compare == 1 && _vm.oldBasicData.licenseType == 1) ? _c('span', {
    staticClass: "main_word"
  }, [_vm._v("普通营业执照")]) : _vm._e(), _vm._v(" "), (_vm.control.compare == 1 && _vm.oldBasicData.licenseType == 2) ? _c('span', {
    staticClass: "main_word"
  }, [_vm._v("三证合一／五证合一")]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "营业执照号："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.basicForm.businessLicenseCode))]), _vm._v(" "), (_vm.control.compare == 1 && _vm.oldBasicData.businessLicenseCode) ? _c('span', {
    staticClass: "main_word"
  }, [_vm._v(_vm._s(_vm.oldBasicData.businessLicenseCode))]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "营业执照电子版："
    }
  }, [_c('div', [_vm._l((_vm.basicForm.businessLicenseFile), function(gtFile) {
    return _c('img', {
      staticClass: "pic_skan",
      attrs: {
        "src": gtFile.url
      },
      on: {
        "click": function($event) {
          _vm.previewPic($event)
        }
      }
    })
  }), _vm._v(" "), _vm._l((_vm.oldBasicData.businessLicenseFile), function(gtFile) {
    return (_vm.control.compare == 1 && _vm.oldBasicData.businessLicenseFile) ? _c('img', {
      staticClass: "pic_skan_red",
      attrs: {
        "src": gtFile.url
      },
      on: {
        "click": function($event) {
          _vm.previewPic($event)
        }
      }
    }) : _vm._e()
  })], 2)]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.basicForm.registeredCountry == 1),
      expression: "basicForm.registeredCountry == 1"
    }],
    attrs: {
      "label": "执照有效期："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.getTimeStr(_vm.basicForm.businessLicenseStartDate)))]), _vm._v(" --\n                "), _c('span', [_vm._v(_vm._s(_vm.getTimeStr(_vm.basicForm.businessLicenseEndDate)))]), _vm._v(" "), ((_vm.control.compare == 1) && (_vm.oldBasicData.businessLicenseStartDate)) ? _c('span', {
    staticClass: "main_word"
  }, [_vm._v("\n                    " + _vm._s(_vm.getTimeStr(_vm.oldBasicData.businessLicenseStartDate)) + " --\n                ")]) : _vm._e(), _vm._v(" "), (_vm.control.compare == 1 && (_vm.oldBasicData.businessLicenseEndDate)) ? _c('span', {
    staticClass: "main_word"
  }, [_vm._v(_vm._s(_vm.getTimeStr(_vm.oldBasicData.businessLicenseEndDate)))]) : _vm._e()]), _vm._v(" "), (_vm.basicForm.licenseType == 1) ? _c('el-form-item', {
    attrs: {
      "label": "组织机构代码："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.basicForm.orgCode))]), _vm._v(" "), (_vm.control.compare == 1 && _vm.oldBasicData.orgCode) ? _c('span', {
    staticClass: "main_word"
  }, [_vm._v(_vm._s(_vm.oldBasicData.orgCode))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.basicForm.licenseType == 1) ? _c('el-form-item', {
    attrs: {
      "label": "组织结构代码电子版："
    }
  }, [_c('div', [_vm._l((_vm.basicForm.orgCodeFile), function(gtFile) {
    return _c('img', {
      staticClass: "pic_skan",
      attrs: {
        "src": gtFile.url
      },
      on: {
        "click": function($event) {
          _vm.previewPic($event)
        }
      }
    })
  }), _vm._v(" "), _vm._l((_vm.oldBasicData.orgCodeFile), function(gtFile) {
    return (_vm.control.compare == 1 && _vm.oldBasicData.orgCodeFile.length) ? _c('img', {
      staticClass: "pic_skan_red",
      attrs: {
        "src": gtFile.url
      },
      on: {
        "click": function($event) {
          _vm.previewPic($event)
        }
      }
    }) : _vm._e()
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.basicForm.licenseType == 1) ? _c('el-form-item', {
    attrs: {
      "label": "税务登记证电子版："
    }
  }, [_c('div', [_vm._l((_vm.basicForm.taxFile), function(gtFile) {
    return _c('img', {
      staticClass: "pic_skan",
      attrs: {
        "src": gtFile.url
      },
      on: {
        "click": function($event) {
          _vm.previewPic($event)
        }
      }
    })
  }), _vm._v(" "), _vm._l((_vm.oldBasicData.taxFile), function(gtFile) {
    return (_vm.control.compare == 1 && _vm.oldBasicData.taxFile) ? _c('img', {
      staticClass: "pic_skan_red",
      attrs: {
        "src": gtFile.url
      },
      on: {
        "click": function($event) {
          _vm.previewPic($event)
        }
      }
    }) : _vm._e()
  })], 2)]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开户许可证电子版："
    }
  }, [_c('div', [_vm._l((_vm.basicForm.accountOpeningPermitFile), function(gtFile) {
    return _c('img', {
      staticClass: "pic_skan",
      attrs: {
        "src": gtFile.url
      },
      on: {
        "click": function($event) {
          _vm.previewPic($event)
        }
      }
    })
  }), _vm._v(" "), _vm._l((_vm.oldBasicData.accountOpeningPermitFile), function(gtFile) {
    return (_vm.control.compare == 1 && _vm.oldBasicData.accountOpeningPermitFile.length > 1) ? _c('img', {
      staticClass: "pic_skan_red",
      attrs: {
        "src": gtFile.url
      },
      on: {
        "click": function($event) {
          _vm.previewPic($event)
        }
      }
    }) : _vm._e()
  })], 2)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "法定代表人证件类型："
    }
  }, [(_vm.basicForm.personalCardType == 1) ? _c('span', [_vm._v("身份证")]) : _vm._e(), _vm._v(" "), (_vm.basicForm.personalCardType == 2) ? _c('span', [_vm._v("护照")]) : _vm._e(), _vm._v(" "), (_vm.control.compare == 1 && _vm.oldBasicData.personalCardType == 1) ? _c('span', {
    staticClass: "main_word"
  }, [_vm._v("身份证")]) : _vm._e(), _vm._v(" "), (_vm.control.compare == 1 && _vm.oldBasicData.personalCardType == 2) ? _c('span', {
    staticClass: "main_word"
  }, [_vm._v("护照")]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "法定代表人身份证件电子版："
    }
  }, [_c('div', [_vm._l((_vm.basicForm.personalCardFile), function(gtFile) {
    return _c('img', {
      staticClass: "pic_skan",
      attrs: {
        "src": gtFile.url
      },
      on: {
        "click": function($event) {
          _vm.previewPic($event)
        }
      }
    })
  }), _vm._v(" "), _vm._l((_vm.oldBasicData.personalCardFile), function(gtFile) {
    return (_vm.control.compare == 1 && _vm.oldBasicData.personalCardFile) ? _c('img', {
      staticClass: "pic_skan_red",
      attrs: {
        "src": gtFile.url
      },
      on: {
        "click": function($event) {
          _vm.previewPic($event)
        }
      }
    }) : _vm._e()
  })], 2)]), _vm._v(" "), _c('el-form-item', {
    staticClass: "mt50 mb50",
    staticStyle: {
      "margin-left": "300px"
    }
  }, [_c('el-button', {
    staticClass: "mr10",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.returnPage
    }
  }, [_vm._v("返回")]), _vm._v(" "), (_vm.control.audit == 1) ? _c('el-button', {
    staticClass: "mr10",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.auditForm(0)
      }
    }
  }, [_vm._v("审核通过")]) : _vm._e(), _vm._v(" "), (_vm.control.audit == 1) ? _c('el-button', {
    staticClass: "mr10",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.auditForm(1)
      }
    }
  }, [_vm._v("审核驳回")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible,
      "size": "small"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cac70fea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/supplierInfo/manage/basicInfo.vue
// module id = 569
// module chunks = 0